import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-decaacc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-4xl font-bold text-primary mx-2" }, "PowerX", -1))
const _hoisted_4 = {
  key: 1,
  class: "ml-auto border-1 surface-border border-round surface-100 text-xs p-1"
}
const _hoisted_5 = {
  key: 1,
  class: "card flex justify-content-start"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-primary pi pi-times" }, null, -1))
const _hoisted_7 = { class: "flex align-items-center justify-content-between w-full" }
const _hoisted_8 = { class: "flex flex-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-4xl font-bold text-primary mx-2" }, "PowerX", -1))
const _hoisted_10 = { class: "flex align-items-center" }
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PTag = _resolveComponent("PTag")!
  const _component_PBadge = _resolveComponent("PBadge")!
  const _component_PMenubar = _resolveComponent("PMenubar")!
  const _component_PPanelMenu = _resolveComponent("PPanelMenu")!
  const _component_PSidebar = _resolveComponent("PSidebar")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PDivider = _resolveComponent("PDivider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.topMenu)
      ? (_openBlock(), _createBlock(_component_PMenubar, {
          key: 0,
          model: _ctx.mainMenuItems,
          class: "flex justify-content-between border-noround border-none"
        }, {
          start: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_PTag, { severity: _ctx.appModeStatus }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.appMode), 1)
                ]),
                _: 1
              }, 8, ["severity"])
            ])
          ]),
          item: _withCtx(({ item, props, hasSubmenu, root }) => [
            _createElementVNode("div", null, [
              _createElementVNode("a", _mergeProps({ class: "flex align-items-center text-primary" }, props.action), [
                _createElementVNode("span", {
                  class: _normalizeClass([item.icon, "mr-2"]),
                  style: {"color":"grey"}
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(item.label), 1),
                (item.badge)
                  ? (_openBlock(), _createBlock(_component_PBadge, {
                      key: 0,
                      class: _normalizeClass({ 'ml-auto': !root, 'ml-2': root }),
                      value: item.badge
                    }, null, 8, ["class", "value"]))
                  : _createCommentVNode("", true),
                (item.shortcut)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.shortcut), 1))
                  : _createCommentVNode("", true),
                hasSubmenu
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 2,
                      class: _normalizeClass(['pi pi-angle-down', { 'pi-angle-down ml-2': root, 'pi-angle-right ml-auto': !root }])
                    }, null, 2))
                  : _createCommentVNode("", true)
              ], 16)
            ])
          ]),
          _: 1
        }, 8, ["model"]))
      : _createCommentVNode("", true),
    (!_ctx.topMenu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_PSidebar, {
            header: "PowerX",
            visible: _ctx.showSidebar,
            "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showSidebar) = $event))
          }, {
            closeicon: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _createVNode(_component_PPanelMenu, { model: _ctx.mainMenuItems }, null, 8, ["model"])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_PButton, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSidebar = true)),
                icon: "pi pi-bars",
                rounded: "",
                text: ""
              }),
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_PTag, { severity: _ctx.appModeStatus }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.appMode), 1)
                  ]),
                  _: 1
                }, 8, ["severity"])
              ])
            ]),
            (!_ctx.topMenu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_PButton, {
                    icon: _ctx.logoutItems.icon,
                    label: _ctx.logoutItems.label,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logoutItems.command())),
                    text: ""
                  }, null, 8, ["icon", "label"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.topMenu)
      ? (_openBlock(), _createBlock(_component_PDivider, {
          key: 2,
          class: "my-2"
        }))
      : _createCommentVNode("", true)
  ]))
}